import React from 'react';
import PropTypes from 'prop-types';
import CalendarPen from '../CalendarPen/CalendarPen';
import { useTranslation } from 'react-i18next';

const CalendarPens = ({ statuses, activeStatus, setActivatedStatus }) => {
  const { t } = useTranslation('resource-portal');

  return (
    <div className="tailwind-root contents">
      <div className="flex flex-wrap gap-2 pr-2">
        {statuses.map(status => (
          <CalendarPen
            key={status.id}
            label={t(`CalendarRoute.status.${status.statusType}`, {
              defaultValue: status.name
            })}
            colour={status.colour}
            onClick={() => setActivatedStatus(status)}
            isActive={activeStatus && activeStatus.id === status.id}
          />
        ))}
      </div>
    </div>
  );
};

CalendarPens.propTypes = {
  statuses: PropTypes.array.isRequired,
  setActivatedStatus: PropTypes.func.isRequired,
  activeStatus: PropTypes.object
};

export default CalendarPens;
